module.exports = __webpack_public_path__ + "static/img/bottle.06470cc6.svg";